module.exports = "https://web-assets.ifttt.com/packs/media/prosumer/image--connect-1-89f6abfc.png";